'use client';

import { Box, Flex, Text, Button } from '@chakra-ui/react';
import LucideIcon from '@/components/ui/LucideIcon';
import { useRef } from 'react';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import { useLoraCarousel } from './hooks/useLoraCarousel';
import LegacyInstagramIcon from '@/assets/LegacyInstagramIcon';

const TrendingNowSection = () => {
  const videoContainerRef = useRef<HTMLDivElement>(null);

  // Use custom hook instead of inline useEffect
  useLoraCarousel({
    containerRef: videoContainerRef,
    playlistId: 'ab291ade-c77f-4b99-0f14-08dcd4839a8e',
    videoHeight: '600',
  });

  return (
    <SectionContainer
      containerInnerProps={{
        backgroundColor: 'common.0',
        paddingY: { base: 8, tablet: 12, desktop: 16 },
      }}
    >
      <Flex direction="column" width="100%" gap={{ base: 6, tablet: 8, desktop: 12 }}>
        <SafeLink href="/trend/" width="100%" _hover={{ textDecoration: 'none' }}>
          <Flex
            alignItems="center"
            width="100%"
            justify={{ base: 'space-between', tablet: 'start' }}
            gap={{ base: 3, tablet: 4 }}
          >
            <Text color="common.100" textStyle="heading2" fontWeight="regular">
              Trending Now
            </Text>
            <LucideIcon name="ChevronRight" boxSize={6} color="common.100" />
          </Flex>
        </SafeLink>

        <Box
          width="100%"
          position="relative"
          height="600px"
          borderRadius="8px"
          overflow="hidden"
          ref={videoContainerRef}
          backgroundColor="rgba(0, 0, 0, 0.1)"
          css={{
            '& carousel-playlist': {
              width: '100%',
              height: '100%',
            },
            '& > *': {
              height: '100%',
            },
          }}
        />

        <Box textAlign="center" marginTop={{ base: 4, tablet: 6 }}>
          <SafeLink
            href="https://www.instagram.com/skinseoul.official/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            width={{ base: 'full', tablet: '332px' }}
          >
            <Button
              backgroundColor="transparent"
              border="1px solid"
              borderColor="common.100"
              borderRadius="8px"
              color="common.100"
              textStyle="body3"
              fontWeight="regular"
              height="48px"
              padding={4}
              width={{ base: 'full', tablet: '332px' }}
              _hover={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }}
            >
              Follow us on <LegacyInstagramIcon />
            </Button>
          </SafeLink>
        </Box>
      </Flex>
    </SectionContainer>
  );
};

export default TrendingNowSection;
